import React from 'react';
import { Box } from '@hub/box';
import { Stack } from '@hub/stack';
import { jsx as _jsx } from "react/jsx-runtime";
const Form = _ref => {
  let {
    onSubmit,
    children,
    gap = 'spacing-md',
    sx = {
      width: '100%'
    }
  } = _ref;
  return /*#__PURE__*/_jsx(Box, {
    as: "form",
    sx: {
      width: '100%'
    },
    onSubmit: onSubmit,
    "data-id": "form_form_Form_Box",
    children: /*#__PURE__*/_jsx(Stack, {
      gap: gap,
      sx: sx,
      "data-id": "form_form_Form_Box_Stack",
      children: children
    })
  });
};
export default Form;